import script from "./SetupSchedulingCard.vue?vue&type=script&setup=true&lang=js"
export * from "./SetupSchedulingCard.vue?vue&type=script&setup=true&lang=js"

import "./SetupSchedulingCard.vue?vue&type=style&index=0&id=5389a866&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5389a866"]])

export default __exports__